import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = () => ({
    marginTop: '-1rem',
});

export const divider: TRuleWithTheme = () => ({
    marginTop: '24px',
});
